import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';
export const findDetail= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/order/orderList?`+params,
        method: 'GET'
    })
}
export const findDetailDownloadExcel= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/order/orderList/downloadExcel?`+params,
        method: 'GET'
    })
}

export const findCompany=()=>{
    return request({
        url: `${baseUrl}/joins-points-mall/v1/company/choose`,
        method: 'GET'
    })
}
export const send=(data)=>{
    return request({
        url: `${baseUrl}/joins-product/v1/order/send`,
        method: 'PUT',
        data: data
    })
}
export const findShop=()=>{
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop/choose`,
        method: 'GET'
    })
}
export const findShopA=()=>{
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionArea`,
        method: 'GET'
    })
}
// 查找配送商
export const findProvider=(params)=>{
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionArea?`+params,
        method: 'GET'
    })
}
export const findSendData=(id)=>{
    return request({
        url: `${baseUrl}/joins-product/v1/order/findSendData/${id}`,
        method: 'GET'
    })
}